import { observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./SidebarContent.css');
const closeIcon = require('assets/close blue icon.svg');

// Props
interface ISidebarContentProps extends IAppOnlyStore {
    onClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
    title: string;
    width: number;
}

// Component
@observer
export class SidebarContent extends React.Component<ISidebarContentProps, {}> {
    constructor(props: ISidebarContentProps) {
        super(props);

        document.documentElement.style.overflow = 'hidden';
    }

    public componentWillUnmount() {
        document.documentElement.style.overflow = null;
    }

    public render() {
        return (
            <div className={s.container}>
                <div
                    className={s.top}
                    style={{ width: this.props.width + 'px' }}
                >
                    <p className={s.title}>{this.props.title}</p>
                    <button className={s.close} onClick={this.props.onClose}>
                        <img src={closeIcon} alt="" />
                    </button>
                </div>

                <div className={s.main}>{this.props.children}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/SidebarContent.tsx